import React, { SyntheticEvent } from 'react';
import { AdminProductFilters } from '@api/graphql/types';
import Input from '@components/Form/Input';
import BoolSelect from '@components/Form/BoolSelect';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import ProductCategorySelect from '@components/Form/ProductCategorySelect';
import ProductStatusSelect from '@components/Form/ProductStatusSelect';

interface PropType {
    onSubmit: (values: AdminProductFilters) => void;
    value: AdminProductFilters;
}

interface StateType {
    value: AdminProductFilters;
    changed: boolean;
}

type Props = PropType & InjectedIntlProps;

class ProductListFilters extends React.Component<Props, StateType> {
    public constructor(props: Props) {
        super(props);

        const { name, ext_id, is_special, is_new, productStatus, is_mpl, category } = props.value;
        this.state = {
            changed: false,
            value: { name, ext_id, is_special, is_new, productStatus, is_mpl, category },
        };
    }

    public componentWillReceiveProps(props: Props) {
        const { name, ext_id, is_special, is_new, productStatus, is_mpl, category } = props.value;
        this.setState({changed: false, value: { name, ext_id, is_special, is_new, productStatus, is_mpl, category }});
    }

    private onInputChange = (value: any, name: keyof AdminProductFilters) => {
        this.setState({changed: true, value: {...this.state.value, [name]: value}});
    }

    private onReset = (e: SyntheticEvent) => {
        e.preventDefault();
        this.setState({value: {
            name: null,
            ext_id: null,
            is_special: null,
            is_new: null,
            productStatus: null,
            is_mpl: null,
            category: null,
        }}, () => {
            this.props.onSubmit(this.state.value);
        });
    }


    public render() {
        const { value } = this.state;

        return (
            <form className="row" onSubmit={(e) => { e.preventDefault(); this.props.onSubmit(this.state.value); }} >
                <div className="form-row">
                    <div className="col-md-2">{this.props.intl.formatMessage({id: 'module.product.filter.is_new'})}
                        <BoolSelect name="is_new" value={this.state.value.is_new} onChange={this.onInputChange} />
                    </div>
                    <div className="col-md-2">{this.props.intl.formatMessage({id: 'module.product.filter.is_special'})}
                        <BoolSelect name="is_special" value={this.state.value.is_special} onChange={this.onInputChange} />
                    </div>
                    <div className="col-md-2">{this.props.intl.formatMessage({id: 'module.product.filter.is_mpl'})}
                        <BoolSelect name="is_mpl" value={this.state.value.is_mpl} onChange={this.onInputChange} />
                    </div>
                    <div className="col-md-2">{this.props.intl.formatMessage({id: 'module.product.filter.productStatus'})}
                        <ProductStatusSelect name="productStatus" value={this.state.value.productStatus} onChangeHandler={this.onInputChange} isClearable={true} />
                    </div>
                    <div className="col-md-4">{this.props.intl.formatMessage({id: 'module.product.filter.name'})}
                        <Input type="text" name="name" value={value.name ? value.name : ''}
                            placeholder={this.props.intl.formatMessage({id: 'module.product.filter.name'})}
                            onChange={this.onInputChange}
                        />
                    </div>
                    <div className="col-md-6">{this.props.intl.formatMessage({id: 'module.product.filter.category'})}
                        <ProductCategorySelect name="category" value={value.category ? value.category : []} onChangeHandler={this.onInputChange} isMulti={true} onlyWithProducts={true} />
                    </div>
                    <div className="col-md-2">{this.props.intl.formatMessage({id: 'module.product.filter.ext_id'})}
                        <Input type="text" name="ext_id" value={value.ext_id ? value.ext_id : ''}
                            placeholder={this.props.intl.formatMessage({id: 'module.product.filter.ext_id'})}
                            onChange={this.onInputChange}
                        />
                    </div>
                    <div className="col-md-2"><br />
                        <button type="submit" className="btn btn-primary btn-block" disabled={!this.state.changed}>
                            {this.props.intl.formatMessage({id: 'common.filter'})}
                        </button>
                    </div>

                    <div className="col-md-2 form-group"><br />
                        <button className="btn btn-danger btn-block" onClick={this.onReset}>
                            <i className="fa fa-redo" /> {this.props.intl.formatMessage({ id: 'common.clear' })}
                        </button>
                    </div>

                </div>
            </form>
        );
    }
}

export default compose(injectIntl)(ProductListFilters);



// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductListFilters.tsx